import React from 'react';

import { TimeType } from '@/proto/metric';

export const CRASH_SHORTCUT_OPTIONS = [
  {
    label: '自定义',
    value: 'custom',
  },
  {
    label: '近1小时',
    value: '近1小时',
  },
  {
    label: '今天',
    value: '今天',
  },
  {
    label: '昨天',
    value: '昨天',
  },
  {
    label: '近7天',
    value: '近7天',
  },
  {
    label: '近30天',
    value: '近30天',
  },
  {
    label: '近90天',
    value: '近90天',
  },
];

export const ISSUE_TIME_TYPE = [
  {
    label: '5分钟聚合',
    value: TimeType.MINUTE5,
  },
  {
    label: '小时聚合',
    value: TimeType.HOUR,
  },
  {
    label: '按天聚合',
    value: TimeType.DAY,
  },
  {
    label: '按周聚合',
    value: TimeType.WEEK,
  },
  {
    label: '按月聚合',
    value: TimeType.MONTH,
  },
];

export const ISSUE_TIME_TYPE_EXCLUDE_MINUTE5 = [
  {
    label: '小时聚合',
    value: TimeType.HOUR,
  },
  {
    label: '按天聚合',
    value: TimeType.DAY,
  },
  {
    label: '按周聚合',
    value: TimeType.WEEK,
  },
  {
    label: '按月聚合',
    value: TimeType.MONTH,
  },
];

// 小时聚合和按填聚合
export const ISSUE_TIME_TYPE_EXCLUDE_HOUR_DAY = [
  {
    label: '小时聚合',
    value: TimeType.HOUR,
  },
  {
    label: '按天聚合',
    value: TimeType.DAY,
  },
];

// 小时聚合和按填聚合
export const ISSUE_TIME_TYPE_INCLUDES_MINITE_HOUR_DAY = [
  {
    label: '5分钟聚合',
    value: TimeType.MINUTE5,
  },
  {
    label: '小时聚合',
    value: TimeType.HOUR,
  },
  {
    label: '按天聚合',
    value: TimeType.DAY,
  },
];

export const COMMON_TIME_TYPE_OPTIONS = [
  {
    label: '上报时间',
    value: 'event_time',
  },
  {
    label: '发生时间',
    value: 'report_time',
  },
];

export const EVENT_TIME_OPTIONS = [{
  label: '上报时间',
  value: 'event_time',
}];

// 禁用上报时间
export const DISABLED_REPORT_TIME_OPTIONS = [{
  label: '上报时间',
  value: 'event_time',
},
{
  label: <span className={'text-[#d9d9d9]'}>发生时间</span>,
  value: 'report_time',
  disabled: true,
}];
